import React, { useState, useEffect } from 'react';
import { Printer } from 'lucide-react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { cn } from '../../lib/utils';

const API_URL = process.env.REACT_APP_API_URL || 'https://monitoring.leetcode.uz/api';

function PrinterSummary() {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    loadData();
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadData = async () => {
    try {
      const response = await axios.get(`${API_URL}/printer/summary`);
      setSummary(response.data.data);
    } catch (err) {
      console.error('Failed to load printer summary:', err);
    }
  };

  const sensitivePercentage = summary
    ? Math.round((summary.sensitive_jobs / summary.total_jobs) * 100) || 0
    : 0;

  const warn = sensitivePercentage > 20;

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Printer className="h-4 w-4 text-primary" />
          Printer Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        {summary ? (
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <div className="text-xs text-muted-foreground">Total Jobs</div>
                <div className="text-2xl font-bold text-foreground tabular-nums">
                  {summary.total_jobs}
                </div>
              </div>
              <div>
                <div className="text-xs text-muted-foreground">Total Pages</div>
                <div className="text-2xl font-bold text-foreground tabular-nums">
                  {summary.total_pages}
                </div>
              </div>
            </div>
            <div>
              <div className="flex justify-between mb-1">
                <span className="text-xs text-muted-foreground">Sensitive Documents</span>
                <span
                  className={cn(
                    'text-xs font-bold',
                    warn ? 'text-destructive' : 'text-muted-foreground'
                  )}
                >
                  {summary.sensitive_jobs} ({sensitivePercentage}%)
                </span>
              </div>
              <Progress
                value={sensitivePercentage}
                indicatorClassName={warn ? 'bg-destructive' : 'bg-primary'}
              />
            </div>
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">No print jobs recorded</p>
        )}
      </CardContent>
    </Card>
  );
}

export default PrinterSummary;
